// extracted by mini-css-extract-plugin
export default {"ideas":"HomeIdeas_ideas__5eaoX"};